import { render, staticRenderFns } from "./footer-index.vue?vue&type=template&id=a613bba0&scoped=true"
import script from "./footer-index.vue?vue&type=script&lang=js"
export * from "./footer-index.vue?vue&type=script&lang=js"
import style0 from "./footer-index.vue?vue&type=style&index=0&id=a613bba0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a613bba0",
  null
  
)

export default component.exports